import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextLineheight"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.75 4.5H22.5V6H12.75V4.5ZM12.75 9H20.25V10.5H12.75V9ZM12.75 13.5H22.5V15H12.75V13.5ZM12.75 18H20.25V19.5H12.75V18ZM8.6925 10.0575L6 7.3725L3.3075 10.065L2.25 9L6 5.25L9.75 9L8.6925 10.0575ZM8.6925 13.9425L6 16.6275L3.3075 13.935L2.25 15L6 18.75L9.75 15L8.6925 13.9425Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextLineheight.vue"]]);
